module.exports = __webpack_public_path__ + "img/icon_DoNot@2x.49947c45.png";